import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=9f4970e8"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports